export class ErrorWithData<TData> extends Error {
  constructor(message: string, public data?: TData) {
    super(message);
  }
}
